import React from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';
import {
  ModalOverlay,
  ModalWrapper,
  ModalHeader,
  ModalTitle,
  CloseButton,
  ModalContent,
  InfoText,
  ModalFooter
} from './style';
import { Button } from '../../RegisterFashionOrder/style';

interface CloseSaleFashionModalProps {
  isOpen: boolean;
  orderId: number;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
}

const CloseSaleFashionModal: React.FC<CloseSaleFashionModalProps> = ({
  isOpen,
  orderId,
  onClose,
  onConfirm,
  isLoading = false
}) => {
  if (!isOpen) {
    return null;
  }

  return ReactDOM.createPortal(
    <ModalOverlay>
      <ModalWrapper>
        <ModalHeader>
          <ModalTitle>Fechar venda - Pedido {orderId}</ModalTitle>
          <CloseButton onClick={onClose}>
            <X size={20} />
          </CloseButton>
        </ModalHeader>

        <ModalContent>
          <InfoText>
            Tem certeza que deseja fechar a venda para o pedido {orderId}?
            <br />
            <br />
            O status do pedido será alterado de &quot;Em orçamento&quot; para &quot;Fechado&quot; e as ordens de produção serão criadas automaticamente.
          </InfoText>
        </ModalContent>

        <ModalFooter>
          <Button variant="outline" onClick={onClose} disabled={isLoading}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={isLoading}>
            {isLoading ? 'Processando...' : 'Concluir venda'}
          </Button>
        </ModalFooter>
      </ModalWrapper>
    </ModalOverlay>,
    document.body
  );
};

export default CloseSaleFashionModal;
